import type { Dispatch, SetStateAction } from 'react';
import { createContext } from 'react';

export type SegmentImmutableTag = {
  id: number;
  name: string;
  segmentIdentifier: string;
};

export type SegmentChatContextType = {
  segmentChatStatus: boolean;
  setSegmentChatStatus: Dispatch<SetStateAction<boolean>>;
  segmentIconUrl: string | null | undefined;
  setSegmentIconUrl: Dispatch<SetStateAction<string | null | undefined>>;
  segmentImmutableTag: SegmentImmutableTag | null;
  setSegmentImmutableTag: Dispatch<SetStateAction<SegmentImmutableTag | null>>;
};

export const SegmentChatContext = createContext<SegmentChatContextType>({
  segmentChatStatus: false,
  setSegmentChatStatus: () => {},
  segmentIconUrl: undefined,
  setSegmentIconUrl: () => {},
  segmentImmutableTag: null,
  setSegmentImmutableTag: () => {},
});
